/**
 * Pretty prints a URL by optionally shortening the host and removing the URI.
 */
export const prettyPrintUrl = (url?: string, shortenHost?: boolean, removeUri?: boolean) => {
  if (!url) {
    return "about:blank";
  }

  try {
    const parsedUrl = new URL(url);
    let host = parsedUrl.hostname;

    if (shortenHost) {
      const parts = host.split(".");
      if (parts.length > 2) {
        host = parts.slice(-2).join(".");
      }
    }

    if (removeUri) {
      return host;
    }

    return host + parsedUrl.pathname;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (_) {
    return url;
  }
};

/**
 * Normalizes a URL by ensuring it starts with a protocol (http:// or https://).
 *
 * If no protocol is present, https:// is prepended.
 */
export const normalizeUrl = (url: string): string => {
  if (!url.trim()) return url;

  // If URL doesn't start with a protocol, add https://
  if (!url.match(/^https?:\/\//i)) {
    return `https://${url}`;
  }

  return url;
};
